import { Users, Bell, Headset, CalendarDays } from 'lucide-react'
import { DiscordIcon } from '@/components/BrandIcons'
import useCommunity from '@/hooks/useCommunity'
import { useLanguage } from '@/localization'

/**
 * Shared blue Discord community banner — identical across the hub, KF1 and
 * Minecraft sites (blue Discord treatment with a subtle red accent). Invite
 * href comes from the shared community data via useCommunity().
 */
export default function DiscordCta() {
  const { discordInvite } = useCommunity()
  const { t } = useLanguage()

  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-16 sm:py-20">
      <div className="relative overflow-hidden rounded-lg border border-red-900/30 bg-gray-950 bg-gradient-to-r from-[#5865F2]/30 via-black/70 to-red-900/30 p-8 md:p-12">
        <div className="absolute inset-0 bg-gradient-to-r from-[#5865F2]/10 to-red-600/10 opacity-50" />
        <div className="relative z-10 flex flex-col items-center justify-between gap-6 md:flex-row">
          <div className="flex items-center gap-5">
            <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-[#5865F2] text-white shadow-lg shadow-[#5865F2]/30">
              <DiscordIcon size={30} />
            </span>
            <div className="text-center md:text-left">
              <h2 className="mb-1 text-2xl font-extrabold text-white md:text-3xl">
                {t('Join Our Community')}
              </h2>
              <p className="text-lg text-gray-300">
                {t('Chat with players, get server updates, find teammates, and connect with admins')}
              </p>
            </div>
          </div>
          <a
            href={discordInvite}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 whitespace-nowrap rounded-lg bg-[#5865F2] px-8 py-4 text-lg font-bold text-white shadow-lg shadow-[#5865F2]/25 transition-colors hover:bg-[#4752C4]"
          >
            <DiscordIcon size={20} />
            {t('Join Discord')}
          </a>
        </div>
        <div className="relative z-10 mt-6 flex flex-wrap justify-center gap-6 text-sm text-gray-200 md:justify-start">
          <span className="flex items-center gap-2">
            <Users size={16} className="text-[#5865F2]" /> {t('Active Community')}
          </span>
          <span className="flex items-center gap-2">
            <Bell size={16} className="text-[#5865F2]" /> {t('Server Announcements')}
          </span>
          <span className="flex items-center gap-2">
            <Headset size={16} className="text-[#5865F2]" /> {t('Admin Support')}
          </span>
          <span className="flex items-center gap-2">
            <CalendarDays size={16} className="text-[#5865F2]" /> {t('Event Updates')}
          </span>
        </div>
      </div>
    </section>
  )
}
